<div class="flex justify-center min-h-screen h-full">
  <div class="max-w-md w-full min-h-full mat-elevation-z4">
    <div
      class="bg-bluePrimary text-white/85 h-14 flex justify-center items-center whitespace-nowrap w-full px-4"
    >
      PROJECT: {{ projectname }}
    </div>

    <div class="p-8">
      <div class="p-8 flex flex-col items-center">
        <div class="flex justify-center">
          <img
            class="w-48 h-full"
            src="assets/img/NW_LOGO.png"
            alt="NameVote Logo"
          />
        </div>
        <div class="text-center text-gray-900 font-medium text-body-md mb-4">
          Welcome to NameVote
        </div>

        <form
          name="loginForm"
          [formGroup]="loginForm"
          novalidate
          class="w-full"
        >
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Name</mat-label>
          <input
            matInput
            type="text"
            placeholder="name"
            formControlName="name"
          />
          <mat-error> Name is required </mat-error>
        </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="email"
              placeholder="Email"
              formControlName="email"
            />
            <mat-error *ngIf="loginForm.get('email').hasError('required')">
              Email is required
            </mat-error>
            <mat-error
              *ngIf="
                !loginForm.get('email').hasError('required') &&
                loginForm.get('email').hasError('email')
              "
            >
              Please enter a valid email address
            </mat-error>
          </mat-form-field>

          <div class="flex justify-center">
            <button
              [disabled]="loginForm.invalid"
              class="w-full mt-2 bg-bluePrimary text-white/85 py-2 rounded"
              (click)="submitCredentials()"
            >
              SUBMIT
            </button>
          </div>

          <mat-error *ngIf="false" class="text-center mt-4">
            Username or password incorrect or not register
          </mat-error>
        </form>
      </div>
    </div>
  </div>
</div>
